import { useCallback, useRef, useState } from "react";
import type { ApiGameMessage } from "../../../../../api/index.ts";
import { useHasViewed } from "../../../../../hooks/use-has-user-viewed.ts";
import { useTimeout } from "../../../../../hooks/use-timeout.ts";
import { useLiveFeedEntries } from "../hooks/use-live-feed-entries.ts";
import { FeaturedMessageToast } from "./Toast.tsx";

export const MostRecentFeaturedMessageToaster = () => {
  const { entries } = useLiveFeedEntries();

  const featuredMessages = entries.filter(
    (entry): entry is ApiGameMessage & { kind: "FEATURED_MESSAGE" } => {
      return entry.kind === "FEATURED_MESSAGE";
    },
  );

  const mostRecentFeaturedMessage = featuredMessages.at(0);

  return mostRecentFeaturedMessage ? (
    <FeaturedMessageController
      key={mostRecentFeaturedMessage.id}
      message={mostRecentFeaturedMessage}
    />
  ) : null;
};

const FeaturedMessageController = ({
  message,
}: {
  message: ApiGameMessage;
}) => {
  const [viewed, setViewed] = useHasViewed(["Featured Message", message.id]);
  // use viewedRef for dev to handle double render issue, where depending on the
  // state would cause the message to be immediately dismissed
  const viewedRef = useRef(viewed);
  const [visible, setVisible] = useState(!viewedRef.current);

  const handleHide = useCallback(() => {
    setVisible(false);
    setViewed();
  }, [setViewed]);

  useTimeout(handleHide, 15000);

  // TODO add animation for this
  return visible ? (
    <FeaturedMessageToast message={message} onDismiss={handleHide} />
  ) : null;
};
